<p-toast></p-toast>
<div class="w-full px-4">
    <div class="w-full flex flex-column gap-3">
        <div class="flex align-items-center justify-content-between">
            <h1 class="text-left font-bold text-4xl m-0">Mindler Test Permissions</h1>
            <p-button icon="pi pi-download" (click)="downloadMindlerTestList()" label="Download Mindler Test List" [loading]="isExportLoading" styleClass="sampleBtn" />
        </div>
        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
            <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Search</h2>
            <form [formGroup]="filterForm" (ngSubmit)="search(1)" class="w-full flex flex-wrap">
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="text-left font-normal text-base" style="color: #424242;">From Date</b>
                <p-calendar formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                  class="w-full" styleClass="cal_full" />
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="text-left font-normal text-base" style="color: #424242;">To Date</b>
                <p-calendar formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                  class="w-full" styleClass="cal_full" />
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="text-left font-normal text-base" style="color: #424242;">Student Name</b>
                <p-autoComplete formControlName= "name" [suggestions]="names"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('name')?.value}"
                  class="w-full" (completeMethod)="filterNames($event)" (onSelect)="applyFilters()" (keydown.enter)="applyFilters()" styleClass="fullWidth" optionValue="name"
                  optionLabel="name">
                </p-autoComplete>
              </div>
             
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="text-left font-normal text-base" style="color: #424242;">Status</b>
                <p-dropdown [options]="statuses" styleClass="selectFull" class="w-full" optionLabel="name"
                  optionValue="value" formControlName="status" filterBy="name" [showClear]="true"
                  appendTo="body" placeholder="Select Admin-State">
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    <div class="flex align-items-center gap-2">
                      <div>{{ selectedOption.name }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ option.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-row align-items-end gap-2 mb-2">
                <p-button label="Search" [loading]="isSearching" [disabled]="filterForm.invalid"
                  styleClass="buttonFull" type="submit" />
                <p-button label="Clear" icon="pi pi-times" severity="secondary" (onClick)="clearFilters()" />
              </div>
            </form>
          </div> 
          <div class="w-full flex flex-column gap-2">
            <h2 class="text-left text-xl font-medium">Student List</h2>
            <p-table *ngIf="students && students.length > 0; else noRecordsFound" [value]="students" [lazyLoadOnInit]="false"
              [paginator]="students.length!=total" [rows]="rowSize" [loading]="isSearching" [totalRecords]="total" [first]="first" [lazy]="true"
              (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]" [showPageLinks]="true"
              styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
              <ng-template pTemplate="header">
                <tr>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Email Address</th>
                  <th>Phone Number</th>
                  <th>Assessment Type</th>
                  <th>Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-student let-i="rowIndex">
                <tr>
                  <td>{{student.firstName}} {{student.lastName}}</td>
                  <td>{{student.gender}}</td>
                  <td>{{student.email}}</td>
                  <td>{{student.phoneNumber}}</td>
                  <td>{{getAssessmentTypeDescription(student.assessmentType)}}</td>
                  <td>
                    <div class="w-auto inline-flex align-items-center gap-2">
                      <p-button *ngIf="student.status==0 || student.status==2" [loading]="isAccepting" label="Accept" icon="pi pi-check"
                        styleClass="accept" (onClick)="acceptTestRequest(student.studentId,i)" />
                      <p-button *ngIf="student.status==0 || student.status==1" [loading]="isRejecting" label="Reject"
                        icon="pi pi-times" styleClass="reject" (onClick)="rejectTestRequest(student.studentId,i)" />
                        <p-button class="px-2" [loading]="isLoading" label="View Profile" icon="pi pi-user"
                        styleClass="w-7rem viewapplication" (click)="viewProfile(student.studentId)" />
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <ng-template #noRecordsFound>
              <div class="w-full flex flex-column align-items-center py-4 gap-5">
                <div class="w-full flex align-items-center justify-content-center">
                  <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
                </div>
                <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
              </div>
            </ng-template>
          </div>
    </div>
</div>